import { render, staticRenderFns } from "./public-notifications-view.vue?vue&type=template&id=7e0aecfa"
import script from "./public-notifications-view.vue?vue&type=script&lang=js"
export * from "./public-notifications-view.vue?vue&type=script&lang=js"
import style0 from "./public-notifications-view.vue?vue&type=style&index=0&id=7e0aecfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports